import { render } from "./AppShellNoLoading.vue?vue&type=template&id=8d90b9ca&scoped=true&ts=true"
import script from "./AppShellNoLoading.vue?vue&type=script&lang=ts"
export * from "./AppShellNoLoading.vue?vue&type=script&lang=ts"

import "./AppShellNoLoading.vue?vue&type=style&index=0&id=8d90b9ca&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d90b9ca"]])

export default __exports__